import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
import { Panel, PanelBody } from '../../../../music24/components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song page; each part uses its own slice of it */
import styles from './SongPage.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The shape of the song page while the catalog loads (design f1): no spinner. */
const SongPageSkeletonComponent: React.FC = () => (
  <div className={styles.page} data-testid="song-page-loading" aria-busy="true">
    <div className="d-flex gap-4 align-items-start">
      <div className={clsx(styles.skeleton, styles.skCover)} />
      <div className="d-flex flex-column gap-2 flex-grow-1">
        <div className={clsx(styles.skeleton, styles.skEyebrow)} />
        <div className={clsx(styles.skeleton, styles.skTitle)} />
        <div className={clsx(styles.skeleton, styles.skSub)} />
      </div>
    </div>
    <Panel>
      <PanelBody className={styles.cardBody}>
        <div className={clsx(styles.skeleton, styles.skRow)} />
        <div className={clsx(styles.skeleton, styles.skRow)} />
        <div className={clsx(styles.skeleton, styles.skRow, styles.skRowShort)} />
      </PanelBody>
    </Panel>
  </div>
);

export const SongPageSkeleton = TypedMemo(SongPageSkeletonComponent);
